__turbopack_context__.v({
  "card": "Sl-Ktq_card",
  "disabledTabWrapper": "Sl-Ktq_disabledTabWrapper",
  "glowPulseEffect": "Sl-Ktq_glowPulseEffect",
  "overlay": "Sl-Ktq_overlay",
  "pulse-animation": "Sl-Ktq_pulse-animation",
  "root": "Sl-Ktq_root",
  "sticky": "Sl-Ktq_sticky",
  "tabsListWrapper": "Sl-Ktq_tabsListWrapper",
  "tabsPanelWrapper": "Sl-Ktq_tabsPanelWrapper",
});
